// src/components/patientlist/FilterBar.tsx
import React from "react";
import "../../css/FilterBar.css";
//import Button from '../common/Button';
import { PatientStatus } from "../../types";
import Button from "../common/Button";

interface FilterBarProps {
  onFilterChange: (filters: {
    emrNumber?: string;
    screeningDate?: string;
    status?: PatientStatus | "";
  }) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({ onFilterChange }) => {
  // In a real app, these states would be managed here or lifted up
  // For simplicity, we'll imagine the parent component handles form submission

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const emrNumber = formData.get("emrNumber") as string;
    const screeningDate = formData.get("screeningDate") as string;
    const status = formData.get("status") as PatientStatus | "";
    onFilterChange({ emrNumber, screeningDate, status });
  };

  return (
    <form className="filter-bar" onSubmit={handleFormSubmit}>
      <div className="filter-group">
        <input
          type="text"
          name="emrNumber"
          placeholder="Search by EMR number"
        />
        <Button type="submit">GO</Button>
      </div>
      <div className="filter-group">
        <input
          type="date"
          name="screeningDate"
          placeholder="Filter by screening Date"
        />
        <Button type="submit">GO</Button>
      </div>
      {/* <div className="filter-group">
        <select name="status">
          <option value="">Sort by Status</option>
          <option value="Pending">Pending</option>
          <option value="Completed">Completed</option>
        </select>
        <Button type="submit">GO</Button>
      </div> */}
    </form>
  );
};

export default FilterBar;
